import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

type LargeCommercialLogoProps = {
  isSelected?: boolean;
};

const LargeCommercialLogo: FC<
  React.PropsWithChildren<LargeCommercialLogoProps>
> = ({ isSelected }) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 144 109"
      className="transition-all fill-current block"
      css={`
        color: ${isSelected ? 'var(--color-primary-light-400)' : '#b7bad5'};
        width: 91px;
        height: fit-content;
        @media (min-width: 768px) {
          width: 143px;
        }
        @media (min-width: 1024px) {
          width: 143px;
        }
      `}
    >
      <path
        d="M99 42.632a.5.5 0 0 0 .5.5H143V108.5H19v-96h80v30.132Z"
        fill="#fff"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143 45.5v63H99v-63h44Z"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="13"
        y="1"
        width="92"
        height="12"
        rx="2"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="19.5"
        cy="100"
        r="8.5"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 75.245c0-5.106-4.03-9.245-9-9.245s-9 4.14-9 9.245v16.51c0 5.106 4.03 9.245 9 9.245s9-4.14 9-9.245v-16.51ZM35 24h-8v9h8v-9ZM49 24h-8v9h8v-9ZM63 24h-8v9h8v-9ZM77 24h-8v9h8v-9ZM91 24h-8v9h8v-9Z"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 72.5v-27h80v27H19Z"
        fill="#fff"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.914 45.13 40.867 65.888M98.428 51.334 73.651 72.592M72.42 45.13 41.606 73.05"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71 87v-4H46v4h25Z"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M135 63v-7h-26v7h26Z"
        fill="#fff"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 90v4h25v-4H46ZM71 101v-4H46v4h25Z"
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.5 81.5h25v27h-25v-27Z"
        fill="#fff"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="null"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 42.5h126v3H17zM15.5 71h87v4h-87z"
      />
      <path
        d="M122.5 82v26"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="8.5" y="98" width="1" height="11" rx=".5" fill="#33344F" />
    </svg>
  );
};

export default LargeCommercialLogo;
